import { FC, useContext } from 'react';
import { Button } from '@appkit4/react-components/button';
import { UserContext } from '@contexts/UserProvider';
import styles from './GithubAuthFailedBanner.module.scss';

interface GithubAuthFailedBannerProps {
    onUpdateToken: () => void;
}

const GithubAuthFailedBanner: FC<GithubAuthFailedBannerProps> = ({ onUpdateToken }) => {
    const { githubLastAuthFailureAt, setGithubLastAuthFailureAt } = useContext(UserContext);

    if (!githubLastAuthFailureAt) {
        return null;
    }

    const handleDismiss = () => {
        setGithubLastAuthFailureAt(null);
    };

    return (
        <div className={styles['auth-failed-banner']} role="alert" aria-live="polite">
            <span className={`${styles['banner-icon']} Appkit4-icon icon-alert-fill`} aria-hidden="true" />
            <span className={styles['banner-message']}>
                GitHub authentication failed. Your token may be expired or revoked.
            </span>
            <div className={styles['banner-actions']}>
                <Button kind="secondary" onClick={onUpdateToken} compact>
                    Update token
                </Button>
                <button
                    className={styles['dismiss-btn']}
                    onClick={handleDismiss}
                    aria-label="Dismiss GitHub auth failure banner">
                    <span className="Appkit4-icon icon-close-outline" aria-hidden="true" />
                </button>
            </div>
        </div>
    );
};

export default GithubAuthFailedBanner;
